import { h } from './element';
import { bindClickoutside, unbindClickoutside } from './event';
import { cssPrefix } from '../config';
import { tf } from '../locale/locale';

let subMenuItems = [
  //设定块
  { parentKey:'insert-block', key: 'insert-block-set', title: tf('contextmenu.set')},
  { parentKey:'insert-block', key: 'insert-block-cancel', title: tf('contextmenu.cancel')},
  //列循环块
  { parentKey:'row-cycle-block', key: 'row-cycle-block-set', title: tf('contextmenu.set')},
  { parentKey:'row-cycle-block', key: 'row-cycle-block-cancel', title: tf('contextmenu.cancel')},
  //行循环块
  { parentKey:'column-cycle-block', key: 'column-cycle-block-set', title: tf('contextmenu.set')},
  { parentKey:'column-cycle-block', key: 'column-cycle-block-cancel', title: tf('contextmenu.cancel')},
  //自定义变量块
  { parentKey:'custom-variable-block', key: 'custom-variable-block-config', title: tf('contextmenu.config')},
  { parentKey:'custom-variable-block', key: 'custom-variable-block-cancel', title: tf('contextmenu.cancel')},
  //子表范围
  // { parentKey:'form-config-area', key: 'form-config-area-set', title: tf('contextmenu.set')},
  { parentKey:'form-config-area', key: 'form-config-area-cancel', title: tf('contextmenu.cancel')},

  //子表标题
  // { parentKey:'form-config-title', key: 'form-config-title-set', title: tf('contextmenu.set')},
  { parentKey:'form-config-title', key: 'form-config-title-cancel', title: tf('contextmenu.cancel')},
  //子表标题行
  // { parentKey:'form-config-title-row', key: 'form-config-title-row-set', title: tf('contextmenu.set')},
  { parentKey:'form-config-title-row', key: 'form-config-title-row-cancel', title: tf('contextmenu.cancel')},
  //子表首选行
  // { parentKey:'form-config-first-row', key: 'form-config-first-row-set', title: tf('contextmenu.set')},
  { parentKey:'form-config-first-row', key: 'form-config-first-row-cancel', title: tf('contextmenu.cancel')},
];

function buildMenuItem(item) {
  return h('div', `${cssPrefix}-context-submenu-item`)
    .on('click', () => {
      this.itemClick(item.key);
      this.hide();
    }).on('mouseenter', (evt) => {
      // this.isHide = false;
      this.show(this.selectType);
    })
    .on('mouseleave', (evt) => {
      
    })
    .children(
      item.title(),
      h('div', 'label').child(item.label || '')
    ).addClass(item.parentKey);
  
}

function buildMenu() {
  return subMenuItems.map(it => buildMenuItem.call(this, it));
}

export default class ContextSubMenu {
	//代码库修改
  constructor(viewFn, isHide = false,showContextmenuAddCol,colLen) {
    this.subMenuItems = buildMenu.call(this);
		
    this.el = h('div', `${cssPrefix}-context-submenu`)
      .children(...this.subMenuItems)
      .hide();
    this.viewFn = viewFn;
    this.itemClick = () => {};
    this.isHide = isHide;
    this.selectType = '';
    this.setMode('range');
  }

  // row-col: the whole rows or the whole cols
  // range: select range
  setMode(mode) {
		//代码库修改，屏蔽
    // const hideEl = this.menuItems[11];
    // if (mode === 'row-col') {
    //   hideEl.show();
    // } else {
    //   hideEl.hide();
    // }
  }

  show(type){
    const { el } = this;
    el.show();
    this.isHide = false;
    console.log("show type......",type);
    this.selectType = type;
    this.subMenuItems.forEach(menuItem => {
      if (menuItem.hasClass(type)) {
        console.log("menuItem111......",menuItem);
        menuItem.show();
      } else {
        menuItem.hide()
      }
    });
    // unbindClickoutside(el);
  }

  hide(type) {
    const { el } = this;
    el.hide();
    this.isHide = true;
    // unbindClickoutside(el);
  }

  setPosition(x, y) {
    if (this.isHide) return;
    const { el } = this;
    el.css('left', `${x}px`);
    el.css('top', `${y}px`);
  
    bindClickoutside(el);
  }
}
